/**
 * Class description
 *
 * Created: 2017-12-14
 * @author jonas
 */

import {GameMode} from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {StateReelSymbol} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {IBetLineWinData} from "@nolimitcity/slot-game/bin/core/server/data/IServerData";
import {
    IIndividualWinPresentationConfig
} from "@nolimitcity/slot-game/bin/core/winpresentation/individualwin/IndividualWinPresentationController";
import {
    BetLineWinIndividualWPController
} from "@nolimitcity/slot-game/bin/game/winpresentation/individualwin/BetLineWinIndividualWPController";
import {TeslaGameConfig} from "../TeslaGameConfig";
import {StateMatrix} from "../utils/StateMatrix";
import {TeslaSymbolUtil} from "../utils/TeslaSymbolUtil";
import {Timeline, TimelineLite} from "gsap";
import {TeslaWinAmountDisplay} from "./initial/views/TeslaWinAmountDisplay";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {Currency} from "@nolimitcity/slot-game/bin/core/balance/Currency";
import {TeslaTextStyles} from "../../config/TeslaTextStyles";
import {Helper} from "@nolimitcity/slot-game/bin/core/utils/Helper";
import {Tesla} from "../Tesla";
import {TeslaBetLineWinPresentationView} from "./initial/views/TeslaBetLineWinPresentationView";

export class TeslaBetLineWinIndividualWPController extends BetLineWinIndividualWPController {
    private _noWinSymbols: StateReelSymbol[];
    private _symbolStates: StateMatrix<string>;
    private _winAmount: PIXI.BitmapText | null;

    constructor(config: IIndividualWinPresentationConfig, name?: string, tweakEnabled?: boolean) {
        super(config, name, tweakEnabled);
        this._noWinSymbols = [];
    }


    protected hasWin(): boolean {
        return super.hasWin() && this._gameData != null && this._gameData.mode == GameMode.NORMAL;
    }


    protected startWinPresentation(): void {
        this._symbolStates = TeslaSymbolUtil.createWinAndNoWinSymbolStateMatrix(<IBetLineWinData[]>this._betWinsData!);
        super.startWinPresentation();
    }

    protected resetWinSymbols(isStop: boolean): void {
        if (isStop) {
            while (this._winSymbols.length > 0) {
                this._winSymbols.pop()!.changeState({
                    state: TeslaGameConfig.instance.SYMBOL_STATES.normal,
                    frames: [-1, -1]
                });
            }
            while (this._noWinSymbols.length > 0) {
                this._noWinSymbols.pop()!.changeState({
                    state: TeslaGameConfig.instance.SYMBOL_STATES.normal,
                    frames: [-1, -1]
                });
            }
        }
    }

    protected getLineAnimation(betLineWinData: IBetLineWinData): Timeline {
        const tl: TimelineLite = new TimelineLite();
        const amountText: PIXI.BitmapText = new PIXI.BitmapText(Currency.formatValue(betLineWinData.multipliedAmount), TeslaTextStyles.INDIVIDUAL_AMOUNT_TEXTSTYLE);
        amountText.maxWidth = 120;

        //Win
        for (let i: number = 0; i < betLineWinData.nrOfSymbols; i++) {
            const symbol = Reels.getSymbol(i, betLineWinData.betLine[i]);
            if (symbol) {
                if (i === betLineWinData.nrOfSymbols - 1) {
                    //adding individual betline amount to last symbol
                    const symPos: number[] = Helper.getSymbolPositions(i, betLineWinData.betLine[i]);
                    amountText.position.set(symPos[0], symPos[1]);
                    amountText.pivot.x = amountText.textWidth * 0.5;
                    amountText.pivot.y = amountText.textHeight * 0.5;
                    amountText.scale.set(amountText.maxWidth / amountText.textWidth, amountText.maxWidth / amountText.textWidth);
                    this._winAmount = amountText;
                    Tesla.betLineWinView.addAmountForToggle(amountText);
                }

                const symbolTl = new TimelineLite();

                symbolTl.add(symbol.changeState({state: TeslaGameConfig.instance.SYMBOL_STATES.win}));
                symbolTl.add(symbol.changeState({state: TeslaGameConfig.instance.SYMBOL_STATES.normal}));
                symbolTl.add(() => {
                    if (this._winAmount) {
                        Tesla.betLineWinView.clearView();
                        this._winAmount.destroy();
                        this._winAmount = null;
                    }
                }, ">");

                tl.add(symbolTl, 0);
                if (this._winSymbols.indexOf(symbol) < 0) {
                    this._winSymbols.push(symbol);
                }
            }
        }

        return tl;
    }


    protected playAllNoWinSymbols(): void {
        let noWinCoords: [number, number][] = this._symbolStates.getAllCoordinatesWithState(TeslaGameConfig.instance.SYMBOL_STATES.noWin.keyword);

        const noWinTl: TimelineLite = new TimelineLite();
        for (let coord of noWinCoords) {
            const symbol = Reels.getSymbol(coord[0], coord[1]);
            if (symbol) {
                let symbolAnimation: Timeline | null = symbol.changeState({
                    state: TeslaGameConfig.instance.SYMBOL_STATES.noWin,
                    fadeInDuration: 0.0
                });
                if (symbolAnimation != null) {
                    noWinTl.add(symbolAnimation, 0);
                }
                this._noWinSymbols.push(symbol);
            }
        }
    }
}